import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ExternalParameters } from '../models/external-parameters';

@Injectable({
  providedIn: 'root'
})
export class ExternalsParametersService {

  private externalParameters: BehaviorSubject<ExternalParameters>;

  public get externalParametersChange$() { return this.externalParameters.asObservable(); }

  constructor() {
    this.externalParameters = new BehaviorSubject<ExternalParameters>(JSON.parse(sessionStorage.getItem('externalParameters') as string));
  }

  loadExternalParameters(parameters: ExternalParameters) {
    sessionStorage.setItem('externalParameters', JSON.stringify(parameters));
    this.externalParameters.next(parameters);
  }

//   resetExternalParameters() {
//     this.externalParameters.next(null);
//     sessionStorage.removeItem('externalParameters');
//   }

  hasExternalParameters(): boolean {
    if (this.externalParameters.value !== null) {
      return true;
    } else {
      return false;
    }
  }
}
